import { Component, Input } from '@angular/core';
import { CartInfo } from '@models/session-details';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';

@Component({
  selector: 'ts-quick-nav',
  templateUrl: './quick-nav.component.html',
  imports: [TranslationPipe]
})
export class QuickNavComponent {
  @Input() navigation_title: string;

  constructor(private activity_manager_svc: ActivityManagerService) {}

  returnToDashboard(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    let active_element: HTMLElement = document.activeElement as HTMLElement;
    active_element.blur();

    if (this.activity_manager_svc.state().isValidCart(CartInfo.cart_data))
      this.activity_manager_svc.cancelCurrentActivity();
    else this.activity_manager_svc.clearCartInBackground();
  }
}
